import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DailyPlanPage } from '@/features/siteplan/daily-plan-page';

const searchSchema = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/daily-plan')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const { date } = Route.useSearch();
  // Keyed by date so a link to another day starts that day's view afresh.
  return <DailyPlanPage key={date ?? 'today'} projectId={projectId} date={date} />;
}
